import React, {useState} from 'react';
//import { Nav, Navbar, Container, NavDropdown, Image } from 'react-bootstrap';

import { Image } from 'react-bootstrap';
import IPLogo from '../../assets/IPLogo.png';
import {useAuth} from '../../auth/AuthContext';
import styled, { css } from 'styled-components'
import { FaBars, FaUser, FaSignOutAlt, FaLock, FaSearch } from 'react-icons/fa';
//import PropTypes from 'prop-types'

import { NavLink as Link} from 'react-router-dom';
import routes from '../../views/routes';


function Header() {
    const { currentUser, logout, currrentPath } = useAuth();
    const [isOpen, setIsOpen] = useState(false);

    const TopHeader = styled.div`
        height: 20px;
        background: #0A3BB4;
        position: fixed;
        width: 100%;
        z-index:100001;
    `;

    const iconCss = css`
        height: 1rem;
        width: 1rem;
    `;

    const UserIcon = styled(FaUser)`
        ${iconCss}
    `;

    const LogoutIcon = styled(FaSignOutAlt)`
        ${iconCss}
        margin-right:5px;
    `;

    const LockIcon = styled(FaLock)`
        ${iconCss}
    `;

    const SearchIcon = styled(FaSearch)`
        ${iconCss}
    `;

    const Navbar1 = styled.div`
    padding: 3px calc((100vw - 1360px) /2);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    background: #F4F4F4;
    margin-bottom:3px;
    max-height: 80px;
    margin-top: 20px;
    position: fixed;
    width: 100%;
    z-index:100001;
    `;

    const Logo1 = styled.a`
    padding: 5px 0;
    color: green;
    text-decoration: none;
    font-weight:800;
    font-size:1.7rem;
    `;

    const Hamburger = styled.div`
    display: none;
    flex-direction: column;
    cursor: pointer;
    margin-right: 24px;

    span {
        height: 2px;
        width:25px;
        background: #7b7fda;
        margin-bottom:4px;
        border-radius:5px
    }

    @media screen and (max-width: 890px) { 
        display:flex;
    }

    `;

    const Menu = styled.div`
    display: flex;
    justify-content: space-between;
    align-items:center;
    position: relative;

    @media screen and (max-width: 890px) {
        background: #F4F4F4;
        margin-top: -2px;
        z-index: 100001;
        overflow: hidden;
        flex-direction: column;
        width: 100%;
        max-height:${({isOpen}) => (isOpen ? "300px" : "0")};
        transition: max-height 0.3s ease-in;
    }
    `;

    const MenuLink = styled(Link)`
    padding: 1.5rem 1rem;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    color: #000;
    transition: all 0.3s ease-in;
    font-size: 0.9rem;
    font-weight: 500;

    &.${props => props.activeClassName} {
        background:white;
        border-top:4px solid red;
        border-radius: 3px;
        margin-bottom: 4px;
    }

    &:hover {
        color: #7b7fba;
        cursor: pointer;
    }

    @media screen and (max-width: 868px) {
        padding: 1.5rem calc((100vw - 70%));
    }

    
    
    `;

    const SideMenu = styled(Menu)`
       a {
        font-weight: 400;
        }
    `;

    // const NavBar = styled(Navbar)`
    //     backgroundColor : #F4F4F4;
    //     height: 80px;
    //     margin-bottom: 5px;
    // `;


    // const Nav = styled.nav`
    //     background: #F4F4F4;
    //     height: 80px;
    //     display: flex;
    //     justify-content: space-between;
    //     padding: 0.5rem calc((100vw - 1360px) /2);
    //     z-index: 10;
    // `;

    const NavLink = styled(Link)`
    padding: 1.5rem 1rem;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    color: #000;
    transition: all 0.3s ease-in;
    font-size: 1rem;
    font-weight: 500;

    &:hover {
        color: #7b7fba;
    }

    @media screen and (max-width: 868px) {
        padding: 1.5rem calc((100vw - 70%));
    }


    ${prop => prop.ariaCurrent  &&
        css`
          background:white;
          border-top:4px solid red;
          border-radius: 3px;
          margin-bottom: 4px;
        `}
    `;

    // const Bars = styled(FaBars)`
    //    display: none;
    //    color: #7b7fda; 

    //    @media screen and (max-width: 768px) {
    //        display: block;
    //        position: absolute;
    //        top: 20;
    //        right: 0;
    //        transform: translate(-100%, 75%);
    //        font-size: 1.8rem;
    //        cursor: pointer;
    //    }
    // `;

    // const NavMenu = styled.div`
    //    display: flex;
    //    align-items: center;
    //    margin-right: -24px;

    //    @media screen and (max-width: 768px) {
    //        display: none;
    //    }
    // `;


    // const NavBtn = styled.nav`
    //    display: flex;
    //    align-items: center;
    //    margin-right: 24px;
       
    //    @media screen and (max-width: 768px) {
    //        display: none;
    //    }
    // `;

    // const NavBtnLink = styled(Link)`
    //    border-radius: 4px;
    //    padding:10px 22px;
    //    background: #256ce1;
    //    color:#fff;
    //    order:none;
    //    outline:none;
    //    cursor:pointer;
    //    transition: all 0.2s ease-in-out;
    //    text-decoration: none;

    //    @:hover {
    //     transition: all 0.2s ease-in-out;
    //     background: #fff;
    //     color: #010606;
    //    }
    // `;


     return(   
        <>
            <TopHeader />
            <Navbar1>
                <Logo1 href="">
                    <Image src={IPLogo} />
                </Logo1>
                <Hamburger onClick={() => setIsOpen(!isOpen)}>
                    <span />
                    <span />
                    <span />
                </Hamburger>
                { currentUser &&
                (<Menu isOpen={isOpen}>
                    <MenuLink to ={currentUser.UserRole == "Admin" ? routes.ADMINCOMPANIES: routes.JOBS} activeClassName onClick={() => setIsOpen(false)}>Home</MenuLink>
                   { currentUser.Company && (<>
                    <MenuLink to ={routes.COMPANYUPDATE} activeClassName onClick={() => setIsOpen(false)}>Company Details</MenuLink>
                    {/* <MenuLink to ={routes.JOBPOST} activeClassName onClick={() => setIsOpen(false)}>Post Job</MenuLink>                    */}
                   </>) }
                   {currentUser.UserRole == "Admin" && <>
                   <MenuLink to ={routes.ADMINVETERANS} activeClassName onClick={() => setIsOpen(false)}>User</MenuLink>
                    <MenuLink to ={routes.ADDCOMPANY} activeClassName onClick={() => setIsOpen(false)}>Add Company</MenuLink>
                    </>
                   }
                </Menu>)
                }

                <SideMenu isOpen={isOpen}>
                    { !currentUser && (<>
                        <MenuLink to={routes.SIGNUP_PAGE} onClick={() => setIsOpen(false)}>
                        <LockIcon fill="#dc2a0b" /> SIGN UP
                    </MenuLink>
                    <MenuLink to={routes.LOGIN_PAGE} onClick={() => setIsOpen(false)}>
                        <UserIcon fill="#2e3192" />  LOGIN
                    </MenuLink></>)
                    }               
                    { currentUser &&
                        (<>                            
                            {/* <MenuLink to ="/login" activeKey={false}>
                                <SearchIcon fill="#dc2a0b" />
                            </MenuLink> */}
                            <MenuLink to='/login' onClick={() => { setIsOpen(false); logout() }}>
                                <LogoutIcon fill="#2e3192" />  LOGOUT
                            </MenuLink>
                        </>)
                    }
                    
                </SideMenu>
            </Navbar1>
        </>
    )
}

export default Header

